var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "featureTableModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal ansi-ft-modal",
            "body-class": "scroll-Container",
            title:
              _vm.layerDefinition == "Intersections"
                ? "Intersections Feature Table"
                : "ANSI Feature Table",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.loadTable()
            },
            hidden: function ($event) {
              _vm.displayUntestedRegions = false
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _vm.untestedRegions.length > 0
                ? _c(
                    "b-col",
                    { attrs: { "align-self": "center", cols: "1" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: _vm.displayUntestedRegions
                              ? "primary"
                              : "secondary",
                            title:
                              (_vm.displayUntestedRegions ? "Hide" : "Show") +
                              " Untested Regions",
                            size: "lg",
                          },
                          on: {
                            click: function ($event) {
                              _vm.displayUntestedRegions =
                                !_vm.displayUntestedRegions
                            },
                          },
                        },
                        [
                          _c("fa", {
                            attrs: {
                              icon: ["fas", "globe-americas"],
                              size: "lg",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.statusCounts, function (element, i) {
                return _c("b-col", { key: i, staticClass: "px-1" }, [
                  _c("div", { staticClass: "ft-status-card" }, [
                    _c("span", { staticClass: "ft-status-count" }, [
                      _vm._v(_vm._s(element.count)),
                    ]),
                    _vm._v(" "),
                    element.Overall
                      ? _c(
                          "span",
                          { staticClass: "ft-status-label capitalize" },
                          [_vm._v(_vm._s(element.Overall))]
                        )
                      : _c("span", { staticClass: "ft-status-label" }, [
                          _vm._v("Not Reviewed"),
                        ]),
                  ]),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.displayUntestedRegions
            ? _c(
                "div",
                { staticClass: "pb-3" },
                [
                  _c(
                    "b-row",
                    [_c("b-col", [_c("h3", [_vm._v("Untested Regions:")])])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "column-count": "5" } },
                    _vm._l(_vm.untestedRegions, function (element, index) {
                      return _c(
                        "b-row",
                        { key: index },
                        [
                          _c("b-col", [
                            _c("ul", { staticClass: "ul-less-margin" }, [
                              _c("li", [_vm._v(_vm._s(element))]),
                            ]),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.layerDefinition == "HD"
            ? _c(
                "b-row",
                { staticClass: "mx-2 my-1" },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-8" },
                    [
                      _c("label", [_vm._v("Layer Types")]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          staticClass: "propStyle",
                          on: {
                            change: function ($event) {
                              return _vm.getTableBySelset()
                            },
                          },
                          model: {
                            value: _vm.hdLayerOption,
                            callback: function ($$v) {
                              _vm.hdLayerOption = $$v
                            },
                            expression: "hdLayerOption",
                          },
                        },
                        _vm._l(_vm.hdLayerList, function (e, i) {
                          return _c(
                            "b-form-select-option",
                            { key: i, attrs: { value: e } },
                            [
                              _vm._v(
                                "\n            " + _vm._s(e) + "\n          "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("MMP_QueryConstructor", {
            staticClass: "show-desktop px-4",
            attrs: {
              comp:
                _vm.layerDefinition == "Intersections"
                  ? "Intersections"
                  : "ANSI",
              fromdate: null,
              todate: null,
              isAdmin: _vm.isAdmin,
              user: _vm.user,
              getPropsApiUrl: _vm.getPropsApiUrl,
              getFilterApiUrl: _vm.getFilterApiUrl,
              getConditions: _vm.getConditions,
              reOpened: _vm.reOpened,
            },
            on: {
              applyCustomQuery: function ($event) {
                return _vm.applyCustomQuery($event)
              },
            },
          }),
          _vm._v(" "),
          _c("vue-bootstrap4-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dataLoaded,
                expression: "dataLoaded",
              },
            ],
            attrs: {
              rows: _vm.rows,
              columns:
                _vm.layerDefinition != "HD" ? _vm.columns : _vm.hdcolumns,
              config: _vm.config,
              classes:
                _vm.layerDefinition != "HD" ? _vm.classes : _vm.hdclasses,
            },
            on: {
              "on-select-row": function ($event) {
                return _vm.zoomToFeature($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }